/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Update revision
 * @export
 * @interface UpdateRevision
 */
export interface UpdateRevision {
  /**
   *
   */
  commitMessage?: string | null;
  /**
   * tags provided as a list of strings
   */
  tags?: Array<string>;
}

/**
 * Check if a given object implements the UpdateRevision interface.
 */
export function instanceOfUpdateRevision(value: object): value is UpdateRevision {
  return true;
}

export function UpdateRevisionFromJSON(json: any): UpdateRevision {
  return UpdateRevisionFromJSONTyped(json, false);
}

export function UpdateRevisionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateRevision {
  if (json == null) {
    return json;
  }
  return {
    commitMessage:
      json["commit_message"] === undefined
        ? undefined
        : json["commit_message"] === null
        ? null
        : json["commit_message"],
    tags: json["tags"] == null ? undefined : json["tags"],
  };
}

export function UpdateRevisionToJSON(json: any): UpdateRevision {
  return UpdateRevisionToJSONTyped(json, false);
}

export function UpdateRevisionToJSONTyped(
  value?: UpdateRevision | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    commit_message: value["commitMessage"],
    tags: value["tags"],
  };
}
